import React from 'react'
import { ApolloProvider } from 'react-apollo'
import Dashboard from './features/dashboard/Dashboard'
import { client } from '../shared/ApolloClient'

export default () => (
  <ApolloProvider client={client}>
    <Dashboard />
  </ApolloProvider>
)
